import Exports from "../../Pages/Mega/Exports";
import {
  ADD_EVENT_FAIL,
  ADD_EVENT_SUCCESS,
  GET_EVENTS_FAIL,
} from "../calendar/actionTypes";
import {
  ADD_APPLESMS_SUCCESS,
  DELETE_APPLESMS_SUCCESS,
  GET_APPLESMS_FAIL,
  GET_APPLESMS_SUCCESS,
  UPDATE_APPLESMS_SUCCESS,
} from "./actionTypes";

const INIT_STATE = {
  applesms: [],
  defective: [],
  exports: [],
  total: 0,
  pagination: { page: 1, per_page: 10, search: "" },
  error: {},
};

const APPLESMS = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_APPLESMS_SUCCESS:
      return {
        ...state,
        ...(action.payload.applesms !== undefined && {
          applesms: action.payload.applesms,
        }),
        ...(action.payload.defective !== undefined && {
          defective: action.payload.defective,
        }),
        total: action.payload.total ?? state.total,
        pagination: {
          page: action.payload.page ?? state.pagination.page,
          per_page: action.payload.per_page ?? state.pagination.per_page,
          search: action.payload.search ?? state.pagination.search,
        },
      };

    case GET_APPLESMS_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_APPLESMS_SUCCESS:
      return {
        ...state,
        applesms: [...state.applesms, action.payload],
      };

    case ADD_EVENT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_APPLESMS_SUCCESS:
      return {
        ...state,
        applesms: state.applesms.map((id) =>
          id.id === action.payload.id ? { id, ...action.payload } : id
        ),
        isEventUpdated: true,
      };

    // case UPDATE_EVENT_FAIL:
    //   return {
    //     ...state,
    //     error: action.payload,
    //     isEventUpdated: false,
    //   };

    case DELETE_APPLESMS_SUCCESS:
      return {
        ...state,
        applesms: state.applesms.filter((id) => id.id !== action.payload),
      };

    // case DELETE_EVENT_FAIL:
    //   return {
    //     ...state,
    //     error: action.payload,
    //   };

    default:
      return state;
  }
};

export default APPLESMS;
